import { render, staticRenderFns } from "./BoardListHomeNewsLayout.vue?vue&type=template&id=4c4a2630&scoped=true&"
import script from "./BoardListHomeNewsLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListHomeNewsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a2630",
  null
  
)

export default component.exports